/**
 * Per-history-entry scroll memory. React Router hands each navigation a unique
 * `location.key`, so we stash the scroll offset under that key when a screen
 * unmounts and restore it when the same entry comes back (i.e. on a back/pop).
 *
 * Forward pushes always get a fresh key, so they correctly start at the top;
 * only a return to a previously-seen entry restores — exactly the UIKit feel.
 * It's a plain module-level Map (memory only): bounded so it can't grow without
 * limit over a long session.
 */
const MAX_ENTRIES = 50;
const positions = new Map<string, number>();

export function saveScroll(key: string, top: number): void {
  // Refresh insertion order so the most-recently-used keys survive eviction.
  positions.delete(key);
  positions.set(key, top);
  if (positions.size > MAX_ENTRIES) {
    const oldest = positions.keys().next().value;
    if (oldest !== undefined) positions.delete(oldest);
  }
}

export function getScroll(key: string): number | undefined {
  return positions.get(key);
}
